<div class="all" (click)="questionnaireClick()">
  <div class="card">
    <!-- <div class="card-header">
      <ng-content select="[card-title]"></ng-content>
    </div> -->
    <div class="card-body">
      <ng-content class="logo" select="[logo]"></ng-content>
      <ng-content></ng-content>
    </div>
  </div>
  <div class="discribe">
    <div class="title-with-menu">
      <div class="flex">
        <div>
          <ng-content select="[name]"></ng-content>
        </div>
        <div *ngIf="!isDisplayUser$() && questionnaire?.status!= enumQStatus.Edit" class="duplicate" (click)="duplicate($event)">
          <img src="/assets/images/plus.svg">
        </div>
      </div>
      <div>
        <que-questionnaires-menu-item [questionnaire]="questionnaire"></que-questionnaires-menu-item>
      </div>
    </div>
    <div class="details">
      <ng-content select="[smartImg]" class="smartImg"></ng-content>
      <div class="date">
        <ng-content select="[startText]"></ng-content>
        <ng-content select="[startDate]"></ng-content>
      </div>
      <ng-content select="[status]"></ng-content>
    </div>
  </div>
</div>